// Header menu toggle. Ports the v5 govuk-frontend `Header` behaviour, which
// was removed in govuk-frontend v6 alongside service-name + navigation support
// in the GOV.UK header.

export default class Header {
  constructor($module) {
    this.$module = $module;
    this.$menuButton = $module.querySelector(".govuk-js-header-toggle");

    if (!this.$menuButton) return;

    const menuId = this.$menuButton.getAttribute("aria-controls");
    this.$menu = menuId ? this.$module.querySelector(`#${CSS.escape(menuId)}`) : null;

    if (!this.$menu) return;

    // `desktop` breakpoint in govuk-frontend is 769px → 48.0625em at the
    // default 16px root font size.
    this.mql = window.matchMedia("(min-width: 48.0625em)");
  }

  init() {
    if (!this.$menuButton || !this.$menu) return;

    this.syncState();

    const onChange = () => this.syncState();
    if (typeof this.mql.addEventListener === "function") {
      this.mql.addEventListener("change", onChange);
    } else {
      this.mql.addListener(onChange);
    }

    this.$menuButton.addEventListener("click", () => this.toggle());
  }

  syncState() {
    this.$menuButton.setAttribute("aria-expanded", "false");

    if (this.mql.matches) {
      this.$menuButton.setAttribute("hidden", "");
      this.$menu.removeAttribute("hidden");
    } else {
      this.$menuButton.removeAttribute("hidden");
      this.$menu.setAttribute("hidden", "");
    }
  }

  toggle() {
    if (this.mql.matches) return;

    const expanded = this.$menuButton.getAttribute("aria-expanded") === "true";
    this.$menuButton.setAttribute("aria-expanded", expanded ? "false" : "true");

    if (expanded) {
      this.$menu.setAttribute("hidden", "");
    } else {
      this.$menu.removeAttribute("hidden");
    }
  }
}
